import { render, staticRenderFns } from "./ProconNumberOfComplaints.container.vue?vue&type=template&id=e57d5e1a&"
import script from "./ProconNumberOfComplaints.container.vue?vue&type=script&lang=ts&"
export * from "./ProconNumberOfComplaints.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports